<template>
    <div class="viewer-container">
        <div id="container">
            <!-- Back button -->
            <BackButton :go-back="back" />
            <!-- Avatar creation title -->
            <div class="title bold">Avatarınızı oluşturalım</div>
            <!-- Instructions list -->
            <div class="desc-list">
                <ul>
                    <li><span>1.</span>QR kodunu mobil cihazınızla tarayın</li>
                    <li><span>2.</span>Selfie çekmek için talimatları izleyin</li>
                    <li><span>3.</span>Masaüstü bilgisayarınıza dönün</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";

/**
 * CreateAvatar
 * 
 * Initial screen for avatar creation process
 * Displays instructions for the user to scan QR code and follow setup process
 * 
 * @component
 */
export default {
    name: 'CreateAvatar',
    components: {
        BackButton
    },
    props: {
        /** Function to navigate back to previous screen */
        goBack: Function,
    },
    data() {
        return {
            // No specific data needed for this component
        }
    },
    methods: {
        /**
         * Navigate back to the list view
         */
        back() {
            this.goBack('list');
        }
    }
}
</script>
<style scoped>
/* Instructions list styles */
.desc-list {
    padding-top: 40px;
}

.desc-list ul {
    list-style: none;
    max-width: 320px;
    margin: 0 auto;
}

.desc-list ul li span {
    padding-right: 10px;
}
.desc-list ul li {
    font-size: 15px;
    font-weight: 300;
    padding-bottom: 15px;
    color: #f7f7f7;
    text-align: left;
}
/* Logo styles */
.logo {
    width: 150px;
    margin: 0 auto;
    padding: 10px 0 0 0;
}
/* Image styles */
img {
    max-width: 100%;
    height: auto;
}
/* Title styles */
.title {
    font-size: 30px;
    padding: 2rem 0 10px 0;
    color: white;
}
/* Description styles */
.desc {
    font-size: 16px;
    padding: 0px 0 10px 0;
    color: white;
}
/* Bold text style */
.bold {
    font-weight: 500;
}
/* Container styles */
#container {
    text-align: center;
}
/* Separator style */
.or {
    color: #f7f7f7;
    padding: 20px 0;
}
/* Create button styles */
.create-button {
    background: transparent;
    border: 1px solid #f7f7f7;
    color: #f7f7f7;
    padding: 10px 20px;
    max-width: 200px;
    border-radius: 10px;
    margin: 0 auto;
    cursor: pointer;
    transition: all .5s;
}
/* Create button hover effect */
.create-button:hover {
    background: #f7f7f7;
    color: #333;
}
</style>